












































































































































































































import Vue, { PropType } from "vue";
import { mapActions, mapMutations } from "vuex";
import downloadIcon from "../../assets/VolumeLicenseUsers/download.svg";

interface VolumeLicensesUsersProps {
  locale: string;
  supportUrl: string;
  baseUrl: string;
  csvDownloadUrl: string;
  lang: any;
  license: any;
  userList: any;
  volumeLicensesId: string;
}

interface VolumeLicensesUsersData {
  existUsingUser: boolean;
  isDeleteSelect: boolean;
  inputRule: string;
  isFinished: boolean;
  isLoading: boolean;
  isSelectAll: boolean;
  selectedUsers: number[];
  showModal: boolean;
}

export default Vue.extend({
  name: "vc-volume-licenses-users",
  components: {
    downloadIcon,
  },
  props: {
    locale: {
      type: String as PropType<VolumeLicensesUsersProps["locale"]>,
      default: "ja-jp",
    },
    supportUrl: {
      type: String as PropType<VolumeLicensesUsersProps["supportUrl"]>,
      default: "",
    },
    baseUrl: {
      type: String as PropType<VolumeLicensesUsersProps["baseUrl"]>,
      default: "",
    },
    csvDownloadUrl: {
      type: String as PropType<VolumeLicensesUsersProps["csvDownloadUrl"]>,
      default: "",
    },
    lang: {
      type: Object as PropType<VolumeLicensesUsersProps["lang"]>,
      default: () => {},
    },
    license: {
      type: Object as PropType<VolumeLicensesUsersProps["license"]>,
      default: () => {},
    },
    userList: {
      type: Array as PropType<VolumeLicensesUsersProps["userList"]>,
      default: () => {},
    },
    volumeLicenseId: {
      type: String as PropType<VolumeLicensesUsersProps["volumeLicensesId"]>,
      default: "",
    },
  },
  data(): VolumeLicensesUsersData {
    return {
      existUsingUser: this.userList.length > 0,
      isDeleteSelect: false,
      inputRule: "required",
      isFinished: false,
      isLoading: false,
      isSelectAll: false,
      selectedUsers: [],
      showModal: false,
    };
  },
  mounted() {
    this.updateVolumeLicenseId(this.volumeLicenseId);
  },
  watch: {
    selectedUsers() {
      this.isSelectAll = this.selectedUsers.length === this.userList.length;
    },
  },
  methods: {
    ...mapActions("common", ["createErrorNotification"]),
    ...mapActions("volumeLicenseUsers", ["deleteCollectLicense"]),
    ...mapMutations("volumeLicenseUsers", ["updateVolumeLicenseId"]),
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    cancelSelect() {
      this.isDeleteSelect = false;
      this.clearSelectAll();
    },
    selectAll() {
      this.isSelectAll = true;
      this.selectedUsers = this.userList.map((user: any) => {
        return user.id;
      });
    },
    clearSelectAll() {
      this.isSelectAll = false;
      this.selectedUsers = [];
    },
    async collectLicenses() {
      try {
        this.isLoading = true;
        await this.deleteCollectLicense({ user_id: this.selectedUsers });
        this.isFinished = true;
      } catch {
        this.createErrorNotification({
          label: this.lang.collect_error,
          style: "is-danger",
          linkLabel: this.lang.link_in_description,
          link: this.supportUrl,
        });
        this.isLoading = false;
        this.closeModal();
      }
    },
    reloadScreen() {
      window.location.reload();
    },
    openUrl(url: string) {
      window.location.href = url;
    },
  },
});
